import { Avatar, Col, Image, Row, Typography } from "antd";
import { setBackEndUlr } from "helpers/SetBackEndUrl";
import StaticPageBanner from "apps/Common/StaticPageBanner";
import { Helmet } from "react-helmet-async";

const MobileAppsIndex = () => {
  const { Text } = Typography;
  return (
    <Row gutter={[0, 20]}>
      <Col xs={24}>
        <Row gutter={[20, 20]}>
          <Col xs={24}>
            <StaticPageBanner
              title="Uygulamalarımız"
              description="Milyonlarca Kullanıcıya Sende Katıl"
            />
                <Helmet>
                                            <title className="capitalize">{"Uygulamalarımız"}</title>
                                      </Helmet>
          </Col>
        </Row>
      </Col>
      <Col xs={24} className="!px-2 lg:!px-6 xxl:!px-16 ">
        <Row className=" !flex items-center !w-full ">
          <Col xs={24} md={12} className="!flex items-center !w-full !h-full">
            <Image
              className="!object-contain !w-full !h-[200px] md:!h-[500px]"
              preview={false}
              src={setBackEndUlr("client") + "/mockup/mockup.png"}
            />
          </Col>
          <Col xs={24} md={12} >
          <Row gutter={[0,10]}>
            <Col xs={24}>
              <Text className="!text-xl md:!text-2xl lg:!text-3xl   xl:!text-5xl !font-bold !text-[#16244c]">
                {" "}
                Milyonlarca Kullanıcıya Sende Katıl
              </Text>
            </Col>
            <Col xs={24}>
              <Text className="!text-lg md:!text-xl    xl:!text-2xl  !text-[#16244c]">
                Emlaktan vasıtaya kadar hepsi Sarı İlanlarda
              </Text>
            </Col>
            <Col xs={24} >
            <Row gutter={[10,10]}>

              <Col  xs={12} xl={12} xxl={9}   >
              <div className="!flex items-center gap-1 !bg-black !px-4 md:!px-8 !py-2 !rounded-md !shadow-md !w-full  ">
                <div>
                  <Avatar
                    className="!w-[30px] !h-[30px] md:!w-[40px] md:!h-[40px]"
                    src={
                      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRsP-EH-Fc-gjQMFgxj4g1pkFGVCK8Y2deHA&s"
                    }
                  />
                </div>
                <div>
                  <div>
                    <Text className="!text-sm  md!text-lg !font-bold !text-white">
                      App Store
                    </Text>
                  </div>
                  <div>
                    <Text className="!text-white">İndirin</Text>
                  </div>
                </div>

              </div>
              </Col>
              <Col xs={12} xl={12} xxl={9} >
              <div className="!flex items-center gap-1 !bg-black !px-4 md:!px-8 !py-2 !rounded-md !shadow-md !w-full  " >
                <div>
                  <Avatar
                   className="!w-[30px] !h-[30px] md:!w-[40px] md:!h-[40px]"
                    src={
                      "https://cdn-icons-png.flaticon.com/512/1532/1532534.png"
                    }
                  />
                </div>
                <div>
                  <div>
                    <Text className="!text-sm  md!text-lg !font-bold !text-white">
                      GooglePlay
                    </Text>
                  </div>
                  <div>
                    <Text className="!text-white">İndirin</Text>
                  </div>
                </div>

              </div>
              </Col>
            </Row>
            </Col>

          </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MobileAppsIndex;
